import { createContext, useContext, type CSSProperties } from "react";

import type { LayoutSettings } from "../types.ts";

export type CombinedUpdate = {
  cssProperties?: Partial<CSSProperties>;
  layoutSettings?: Partial<LayoutSettings>;
};

type ContextValues = {
  cssProperties: Partial<CSSProperties>;
  onCssPropertiesChange: (values: Partial<CSSProperties>) => void;
  layoutSettings: LayoutSettings;
  onLayoutSettingsChange: (values: Partial<LayoutSettings>) => void;
  /** Update both CSS properties and layout settings atomically to avoid race conditions */
  onChange: (values: CombinedUpdate) => void;
  isEditingElementState: boolean;
};

const defaultLayoutSettings: LayoutSettings = {
  verticalBehavior: "fill",
  horizontalBehavior: "fill",
};

export const EditingCssPropertiesContext = createContext<ContextValues>({
  cssProperties: {},
  onCssPropertiesChange: () => {},
  layoutSettings: defaultLayoutSettings,
  onLayoutSettingsChange: () => {},
  onChange: () => {},
  isEditingElementState: false,
});

export const useEditingCss = (): ContextValues => {
  return useContext(EditingCssPropertiesContext);
};
